import { NamePath } from 'antd/es/form/interface'
import * as React from 'react'
import { FC } from 'react'
import Tube from '../../../../../../types/api/tube'
import { EditableContext } from '../editable-row'
import { DatePicker, Form } from 'antd'
import { outputDateFormat } from '../../../../../../constants/constants'
import { EndpointQueryParameters } from '../../../../../../types/strapi/strapi'
import { useSaveOrder } from '../../../../helpers/use-save-order'

interface EditableDateProps {
    namePath: NamePath
    record: Tube
    inputRef: any
    queryParams: EndpointQueryParameters

    toggleEdit: () => void
}

const EditableDate: FC<EditableDateProps> = ({
    namePath,
    record,
    inputRef,
    queryParams,
    toggleEdit,
}) => {
    const form = React.useContext(EditableContext)
    const saveOrder = useSaveOrder()

    const save = async () => {
        try {
            toggleEdit()
            if (!form) return
            const value = form.getFieldsValue()

            if (record.stamps?.[0]?.last_order) {
                const estimatedDate = value?.stamps?.[0]?.last_order?.estimatedDate
                if (estimatedDate !== undefined) {
                    await saveOrder('estimatedDate', estimatedDate, record, queryParams)
                }
            }
        } catch (errInfo) {
            console.log('Save failed:', errInfo)
        }
    }
    return (
        <Form.Item
            style={{
                margin: 0,
            }}
            name={namePath}
        >
            <DatePicker format={outputDateFormat} ref={inputRef} onChange={save} />
        </Form.Item>
    )
}

export default EditableDate
